
<template>
  <div class="mobilemenue_warp">
      <div class="items">
        <router-link tag="div" to="/front/casino" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-casino1.png" alt=""></div>
          <div class="n">카지노</div>
        </router-link>
        <router-link tag="div" to="/front/slot" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-slot.png" alt=""></div>
          <div class="n">슬롯</div>
        </router-link>
        <div class="line"></div>
        <router-link tag="div" to="/front/recharge" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-recharge.png" alt=""></div>
          <div class="n">충전</div>
        </router-link>
        <router-link tag="div" to="/front/exchange" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-exchange.png" alt=""></div>
          <div class="n">환전</div>
        </router-link>
        <router-link tag="div" to="/front/notice" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-notice.png" alt=""></div>
          <div class="n">공지사항</div>
        </router-link>
        <router-link tag="div" to="/front/event" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-event.png" alt=""></div>
          <div class="n">이벤트</div>
        </router-link>
        <router-link tag="div" to="/front/customercenter" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-customercenter.png" alt=""></div>
          <div class="n">고객센터</div>
        </router-link>
        <router-link tag="div" to="/front/casinoslotbetinfo" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-casinobetinfo.png" alt=""></div>
          <div class="n">베팅내역</div>
        </router-link>
<!--        <router-link tag="div" to="/front/coupon" class="itm" @click.native="hideLeftMenu">-->
<!--          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-coupon.png" alt=""></div>-->
<!--          <div class="n">쿠폰</div>-->
<!--        </router-link>-->
        <router-link tag="div" to="/front/userinfo" class="itm" @click.native="hideLeftMenu">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-userinfo.png" alt=""></div>
          <div class="n">회원정보</div>
        </router-link>
<!--        <router-link tag="div" to="/front/refusers" class="itm" @click.native="hideLeftMenu">-->
<!--          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-refusers.png" alt=""></div>-->
<!--          <div class="n">추천인</div>-->
<!--        </router-link>-->
        <div class="line"></div>
        <div class="itm" @click="logout" v-if="$store.state.isLogin === true">
          <div class="pic"> <img src="../../../assets/images/icon/mobile/menu/mm-sign-out.png" alt=""></div>
          <div class="n">로그아웃</div>
        </div>
      </div>

  </div>
</template>



<script>

import {INIT_USERINFO} from "@/store/mutation-types";
import {logout} from "@/network/userRequest";

export default {
  name: "MobileMenu",
  data() {
    return {

    }
  },
  methods: {
    hideLeftMenu(){
      this.mobilemask = true;
      this.$bus.$emit('activeLeftMenu', false);
    },
    logout() {
      this.mobilemask = true;
      this.$bus.$emit('activeLeftMenu', false);
      this.$swal({
        title: '로그아웃 하시겠습니까 ?',
        type: 'question',
        confirmButtonText: ' 예 ',
        cancelButtonText: '아니오'
      }).then((res) => {
        if (res.value) {
          this.$store.commit(INIT_USERINFO);
          window.sessionStorage.clear();
          this.$store.state.isLogin = false;
          //this.$router.replace("/memberlogin")
          this.$router.replace("/front/main")
          this.$store.state.uncheckedMessageCount = 0;
          logout();
        }
      })

    },
  },
}
</script>

<style scoped>
.mobilemenue_warp{
  display: flex;
  width: 100%;
  height: 100vh;
  --background:rgba(0,0,0,.4);
  z-index: 100;
}
.mobilemenue_warp .items{
  width: 27rem;
  height: 100%;
  background: #444444;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-direction: column;
  --border-right: 1px solid #e7e7e7;
  padding: 2rem 2rem;
}

.mobilemenue_warp .items .logo img{
  height: 4rem;
}
.mobilemenue_warp .items .itm{
  width: 100%;
  height: 4rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  margin: .5rem 0;

}
.mobilemenue_warp .items .itm .pic{
  width: 30%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.mobilemenue_warp .items .itm .n{
  width: 70%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: #ffffff;
  padding-left: 1rem;
  font-weight: bold;
}
.mobilemenue_warp .items .itm img{
  height: 3rem;
  --animation: pulse;
  animation: swing;
  animation-duration: 2.2s;
  animation-iteration-count: infinite ;
}

.mobilemenue_warp .line{
  width: 100%;
  height: .2rem;
  border-top:1px solid #8d7024;
  border-bottom:1px solid #4d3200;

}
</style>